module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-700.fa4bbb50.woff2";